/* unplugin-vue-components disabled */import script from "./amazonDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./amazonDetail.vue?vue&type=script&setup=true&lang=ts"

import "./amazonDetail.vue?vue&type=style&index=0&id=2fc942f2&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fc942f2"]])

export default __exports__